import React from 'react';
import { ActivationStatus } from '../../../enums';
import { Tooltip } from '@keplerco/core';
import { ActivationStatusIcon } from '../../user-management/people/assets/activation-status.icon';

// header actions
export const filterableColumns = [ 'Status'];

// tables
export function PersonActivationStatusIcon(props: { status: ActivationStatus }): JSX.Element {
  let statusExplainer = '';
  if (props.status === ActivationStatus.Inactive) statusExplainer = `This user has not activated their account`;
  else if (props.status === ActivationStatus.NotInvited) statusExplainer = `This user has not been invited`;

  if (!statusExplainer) {
    return <ActivationStatusIcon status={props.status} />;
  }

  return (
    <Tooltip content={statusExplainer}>
      <ActivationStatusIcon status={props.status} />
    </Tooltip>
  );
}